import {
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  MatSlideToggleChange,
  MatSlideToggleModule,
} from '@angular/material/slide-toggle';
//import { ThemeSwitchService } from 'app/services/theme.service';
import { MatIconModule } from '@angular/material/icon';

import {
  FuseConfig,
  FuseConfigService,
  Scheme,
  Theme,
  Themes,
} from '@fuse/services/config';
import { Subject, takeUntil } from 'rxjs';
import { MatSliderModule } from '@angular/material/slider';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FormsModule } from '@angular/forms';
import { ThemeService } from 'app/layout/common/themeswitch/theme.service';

@Component({
  selector: 'themeswitch',
  imports: [
    FormsModule,
    MatButtonToggleModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatIconModule,
  ],
  templateUrl: './themeswitch.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './themeswitch.component.scss',
})
export class ThemeSwitchComponent implements OnInit {
  private _fuseConfigService = inject(FuseConfigService);
  private themeService = inject(ThemeService);

  isDarkMode = { darkMode: false };
  config: FuseConfig;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  schemeIndex = 0;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]); // 0: Auto, 1: Light, 2: Dark

  constructor() {}

  ngOnInit(): void {
    // //this.themeService.apply();
    this.isDarkMode = this.themeService.getLocalStorageItem('theme');
    if (this.isDarkMode.darkMode != null && this.isDarkMode.darkMode) {
      this.setScheme('dark');
      this.themeService.setDarkMode();
    } else {
      this.setScheme('light');
      this.themeService.setLightMode();
    }

    // Subscribe to config changes
    this._fuseConfigService.config$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((config: FuseConfig) => {
        // Store the config
        this.config = config;
      });
  }

  onSchemeChange(): void {
    this.setScheme(this.config.scheme);
    if (this.config.scheme == 'dark') {
      this.themeService.setDarkMode();
    } else {
      this.themeService.setLightMode();
    }
  }

  toggleTheme() {
    this.config.scheme = this.config.scheme === 'light' ? 'dark' : 'light';
    this.onSchemeChange();
  }

  /**
   * Set the scheme on the config
   *
   * @param scheme
   */
  setScheme(scheme: Scheme): void {
    this._fuseConfigService.config = { scheme };
  }
}
